<ngx-smart-modal #myModal1 identifier="myModal1">
   <h2 class="modalError">Please login and subscribe to access this content.</h2>
   <button class="modalErrorButton" (click)="myModal1.close()" routerLink="/login">Login Now</button>
 </ngx-smart-modal>
 <!-- <ngx-smart-modal #myModal2 identifier="myModal2">
   <h2 class="modalError">Oh No, something went wrong, please refresh the page.</h2>
   <button class="modalErrorButton" (click)="myModal2.close(); refresh()" >Refresh Now</button>
 </ngx-smart-modal> -->
<app-header ></app-header>
<div id="wrapper">
<app-sidebar></app-sidebar>
<div id="content-wrapper">
<div class="container-fluid pb-0">
  <div class="video-block section-padding">
     <div class="row">
        <div class="col-md-12">
           <div class="main-title">
             <h6 i18n="@@Categories | Categories Page Heading">Categories</h6>
           </div>
        </div>
        <div *ngFor="let tag of alltags | slice:0:6; let i=index;" class="col-xl-3 col-sm-6 mb-3">
            <div class="channels-card">
               <div class="channels-card-image video-box">
                  <a routerLink="/category/{{tag.id}}"><img class="img-fluid" src={{tag.profileUrl}} alt=""></a>
                   </div>
               <div class="channels-card-body">
                  <div class="channels-title">
                     <a routerLink="/category/{{tag.id}}">{{tag.text}}</a>
                  </div>
               </div>
            </div>
         </div>
           </div>
        </div>
 
  <hr>
  
</div>
</div>
</div>
<app-footer></app-footer>